export default {
	"nav.upgrade.button": "订阅",

	"nav.user.dropdown.billing": "账单",
	"nav.user.dropdown.team": "团队设置",
	"nav.user.dropdown.account": "账户设置",
	"nav.user.dropdown.referrals": "邀请有礼",
	"nav.user.dropdown.logout": "退出登录",
}
